<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "OffersPage",
  components: {LoadingPage},

  setup() {

    let loading = ref(false)
    let offers = ref([])

    function load_offers() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'offers', true).then((res) => {

        loading.value = false
        offers.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_offers)
      })

    }
    load_offers()

    return {

      offers,
      loading,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">ثبت پیشنهاد خرید</p>
        <router-link :to="{name:'ProfilePage'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="w-100 p-body bg-main">

      <div v-if="offers.length === 0 && !loading" style="height: 45vh" class="d-flex justify-content-center align-items-end w-100 animate__animated animate__fadeIn">
        <div class="d-flex flex-column align-items-center justify-content-end">
          <img src="../assets/img/empty.png" class="mb-3 w-50" alt="">
          <p class="font-3 font-bold">آیتمی برای نمایش وجود ندارد!</p>
        </div>
      </div>

      <div v-else class="">

        <router-link :to="{name:'OffersShop' , params:{offer_id:item.id , name:item.name}}" v-for="item in offers" :key="item.id"
             class="animate__animated animate__fadeInRight text-decoration-none bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
          <div class="w-60 ml-3 d-flex flex-column justify-content-around">
            <div class="overflow-hidden">
            <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
            </div>

            <div class="overflow-hidden">
            <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
            </div>

            <div class="d-flex align-items-end mb-2">
              <img src="../assets/img/package2.png" class="icon-size-1">

              <p class="font-6 mr-1">حجم محصول :</p>

              <div class="overflow-hidden">
              <p :class="item.unit.length + item.pnum.toString().length > 15 ? 'txtoverflow':'' " class="font-5 font-color font-bold d-flex align-items-center">
                <span class="ml-1">{{ item.pnum }}</span>
                <span class="">{{ item.unit }}</span>
              </p>
              </div>
            </div>

            <div class="d-flex align-items-end">
              <img src="../assets/img/credit2.png" class="icon-size-1">

              <p class="font-6 mr-1">قیمت محصول :</p>

              <p class="mx-1 font-color font-bold d-flex align-items-end">
                <span class="font-5">{{ item.price.toLocaleString() }}</span>
                <span class="font-6 mr-1">تومان</span>
              </p>
            </div>

            <div class="div_hr my-2"></div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center">
                <img class="icon-size-0-5 ml-2" src="../assets/img/store_light.svg" alt="">
                <p class="font-5">{{ item.shops_count }} فروشگاه</p>
              </div>

              <button class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</button>
            </div>

          </div>

          <div class="img_prod rounded-3 animated-background">
            <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
          </div>
        </router-link>

      </div>
    </div>

    <br>
    <br>
    <br>

    <div class="px-3 w-100 bottom-0 position-fixed max_width">
      <router-link :to="{name:'AddOffers'}">
        <v-btn class="text-decoration-none h-100 p-3 my-4 w-100 shadow-custom rounded-3 bg-color text-white">ثبت پیشنهاد
          جدید
        </v-btn>
      </router-link>
    </div>

  </div>

</template>


<style scoped>

@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}

.img_prod {
  width: 40%;
  height: 11.3rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.icon_shop {
  width: 15px;
}
</style>